export default {
  loyaltyInfo: null,
  showLoyalty: true,
  rewards: null,
  myActivitiesTab: null,
}
